
// Re-export the client
export { supabase } from './client';

// Re-export all types
export * from './types';

// Re-export all auth functions
export * from './auth';

// Re-export all database functions
export * from './database';

// Re-export security setup functions
export * from './setupSecurity';

// Re-export the class scheduler as a named export
export const scheduleClasses = async (weeksAhead: number = 8): Promise<{ success: boolean; created: number; error?: string }> => {
  console.log(`Scheduling classes for ${weeksAhead} weeks ahead`);
  const { scheduleClassesForUpcomingWeeks } = await import('../classScheduler');
  return scheduleClassesForUpcomingWeeks(weeksAhead);
};

// Export the updateBookingPaymentStatus function
export { updateBookingPaymentStatus, rescheduleBooking } from './db/bookings';
